var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2Tvbd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5853 37C10.4255 37 3 29.3889 3 20C3 10.6112 10.4255 3 19.5853 3C28.7451 3 36.1707 10.6112 36.1707 20C36.1707 22.7195 35.5477 25.2898 34.4401 27.5692C34.1457 28.175 34.0478 28.8673 34.2184 29.521L35.2062 33.3053C35.6351 34.948 34.1688 36.451 32.5662 36.0114L28.8741 34.9989C28.2364 34.824 27.5608 34.9244 26.97 35.2261C24.7461 36.3615 22.2384 37 19.5853 37Z",
    fill: "url(#paint0_linear_2101_7)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2101_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6098 12H12V28H27.6098V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2101_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.678 22.4029C25.875 21.5792 24.7609 21.2303 23.3299 21.6233L18.2276 16.3881L18.295 16.1267C18.589 14.9965 18.2714 13.7817 17.4666 12.9568C16.6472 12.1163 15.4823 11.8079 14.3807 12.1181C14.2236 12.1623 14.1013 12.2888 14.0597 12.4503C14.018 12.6117 14.0637 12.7834 14.1788 12.9015L15.4074 14.1607C15.7666 14.5298 15.7631 15.1209 15.4083 15.4855C15.0563 15.8472 14.4647 15.8467 14.1141 15.4864L12.8853 14.2268C12.77 14.1086 12.6021 14.0623 12.4446 14.1052C12.287 14.1481 12.1641 14.2737 12.1211 14.4349C11.8229 15.5517 12.1163 16.7531 12.9396 17.597C13.7421 18.4203 14.8549 18.7705 16.2867 18.3766L21.3895 23.6118C21.0087 25.0781 21.3372 26.209 22.1509 27.0431C22.9713 27.8847 24.1368 28.1908 25.236 27.8816C25.3932 27.8375 25.5155 27.7109 25.5572 27.5494C25.5987 27.388 25.5532 27.2163 25.4379 27.0982L24.2097 25.8392C23.8504 25.4701 23.8539 24.879 24.2088 24.5144C24.5652 24.151 25.1555 24.1568 25.503 24.514L26.7319 25.7732C26.8471 25.8913 27.015 25.9377 27.1725 25.8948C27.33 25.8519 27.4531 25.7263 27.496 25.5651C27.7942 24.4485 27.501 23.2468 26.678 22.4029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8948 20.3308L12.5353 24.7999C11.8219 25.5312 11.8219 26.7203 12.5353 27.4516C13.2488 28.1829 14.409 28.1829 15.1224 27.4516L19.4818 22.9827L16.8948 20.3308ZM14.6928 25.9969C14.5141 26.18 14.2248 26.18 14.0461 25.9969C13.8674 25.8138 13.8674 25.5172 14.0461 25.3341L16.8199 22.4904C16.9985 22.3073 17.2879 22.3073 17.4665 22.4904C17.6452 22.6735 17.6452 22.9701 17.4665 23.1532L14.6928 25.9969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4755 12.9454L26.6871 12.1373C26.5387 11.9852 26.3084 11.9562 26.1285 12.0668L23.7033 13.5581C23.4481 13.715 23.4048 14.0758 23.6151 14.2915L23.8082 14.4893L20.7296 17.632L22.0233 18.9581L25.102 15.8154L25.3739 16.0942C25.5843 16.3098 25.9363 16.2654 26.0894 16.0038L27.5443 13.518C27.6522 13.3335 27.6238 13.0975 27.4755 12.9454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2101_7",
    x1: 23.6011,
    y1: 11.6587,
    x2: 15.0401,
    y2: 28.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFA801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9102"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Tvbd);
export default __webpack_public_path__ + "static/media/L2tvbd.f8a56c02904a03852f987995d5bf471f.svg";
export { ForwardRef as ReactComponent };